import { render, staticRenderFns } from "./IABFPieces.vue?vue&type=template&id=0dd21cc9"
import script from "./IABFPieces.vue?vue&type=script&lang=js"
export * from "./IABFPieces.vue?vue&type=script&lang=js"
import style0 from "./IABFPieces.vue?vue&type=style&index=0&id=0dd21cc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports